import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"close\"><defs><style>#close .cls-1{fill:none}</style></defs><title>资源 85</title><g id=\"close_图层_2\" data-name=\"图层 2\"><g id=\"close_图层_1-2\" data-name=\"图层 1\"><path id=\"close_Rectangle_36_Copy\" data-name=\"Rectangle 36 Copy\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"close_close\"><path id=\"close_Shape\" d=\"M13.31 12l6-6a.93.93 0 0 0-.08-1.3.92.92 0 0 0-1.22 0l-6 6-6-6A.92.92 0 0 0 4.73 6l6 6-6 6a.93.93 0 0 0 .08 1.3.92.92 0 0 0 1.22 0l6-6 6 6a.92.92 0 0 0 1.3-1.3z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/close.svg
// module id = usbd
// module chunks = 6